// biome-ignore lint/suspicious/noShadowRestrictedNames: TODO
import { GoogleMap as Map, Marker } from '@react-google-maps/api'
import styled from 'styled-components'

const StyledNoMap = styled.div`
  display: flex;
  width: ${props => props.customMapWidth || '100%'};
  height: ${props => props.customMapHeight || '300px'};
  max-width: 100%;
  padding: 12px;
  text-align: center;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #efefef;
`

function RenderMap(props) {
  const { id, loadError, coordinates, mapOptions } = props

  const { customMapWidth, customMapHeight, disableGoogleUI = true, disableZoom = true, withMarker = true } = mapOptions

  const mapContainerStyle = {
    width: customMapWidth ? `${customMapWidth}px` : '100%',
    height: customMapHeight ? `${customMapHeight}px` : '300px',
  }

  if (loadError || !coordinates) {
    return (
      <StyledNoMap customMapWidth={customMapWidth} customMapHeight={customMapHeight}>
        <h4>Map cannot be displayed.</h4>
        <p>Please check there is an address and it is entered correctly.</p>
      </StyledNoMap>
    )
  }

  return (
    <Map
      id={`${id}-canvas`}
      mapContainerStyle={mapContainerStyle}
      zoom={16}
      center={coordinates}
      options={{
        disableDefaultUI: disableGoogleUI,
        gestureHandling: 'none',
        zoomControl: !disableZoom,
      }}
    >
      {withMarker && <Marker position={coordinates} />}
    </Map>
  )
}

export default RenderMap
